import React, { useState, useEffect } from 'react';
import CwFPagination from 'components/CwFPagination';
import PropTypes from 'prop-types';
import { Redirect, useHistory } from 'react-router-dom';
import Paper from 'components/Paper';
import SortableTable from 'components/UiKit/SortableTable';
import { tableColumns } from 'screens/Equipment/EquipmentItem/helpers/constants';
import LandingList from 'components/LandingList';
import { equipmentTableSort } from 'screens/Equipment/EquipmentItem/helpers/dataHelpers';
import { paths } from 'routes/paths';
import EquipmentTableCell from './EquipmentTableCell';
import DeleteEquipmentModal from '../DeleteEquipmentModal';

const equipmentListDefaultPropEquipments = [];
const getEquipmentTableBodyHeight = () =>
  Math.max(180, window.innerHeight - 380);

const EquipmentList = ({
  equipments = equipmentListDefaultPropEquipments,
  isSearch = false,
  totalEquipments,
  equipmentPageNumber,
  handlePageChange,
  setItems
}) => {
  const [sortField, setSortField] = useState();
  const [sortDir, setSortDir] = useState();
  const [tableBodyHeight, setTableBodyHeight] = useState(
    getEquipmentTableBodyHeight
  );
  const [filteredEquipments, setFilteredEquipments] = useState(equipments);
  const [idToDel, setIDtoDel] = useState();
  const [nameToDel, setNametoDel] = useState();
  const history = useHistory();
  // const [redirect, setRedirect] = useState(false);
  const redirect = false;
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const openDeleteModal = () => setDeleteModalOpen(true);
  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
  };
  useEffect(() => {
    setFilteredEquipments(equipments);
  }, [equipments]);

  useEffect(() => {
    const updateTableBodyHeight = () =>
      setTableBodyHeight(getEquipmentTableBodyHeight());
    window.addEventListener('resize', updateTableBodyHeight);
    return () => window.removeEventListener('resize', updateTableBodyHeight);
  }, []);

  const handleSort = (field, dir) => {
    setSortField(field);
    setSortDir(dir);
    setFilteredEquipments(equipmentTableSort(filteredEquipments, field, dir));
  };

  const handleAction = async (action, { id, name }) => {
    switch (action) {
      case 'view':
        history.push({
          pathname: `${paths.equipment}/${id}/view`,
          itemId: id
        });
        break;
      case 'edit':
        history.push(`${paths.equipment}/${id}`);
        break;
      case 'delete':
        setIDtoDel(id);
        setNametoDel(name);
        openDeleteModal();
        break;
      default:
        break;
    }
  };
  return (
    <div data-testid="equipment-list">
      <DeleteEquipmentModal
        open={deleteModalOpen}
        close={closeDeleteModal}
        equipmentName={nameToDel}
        equipmentId={idToDel}
        setItems={setItems}
        equipments={equipments}
      />
      {redirect && <Redirect push to={`${redirect}`} />}
      {equipments.length > 0 ? (
        <Paper className="cwf-table-flush equipment-list-paper">
          {CwFPagination(
            totalEquipments,
            equipmentPageNumber,
            handlePageChange
          )}
          <SortableTable
            data-testid="landing-table"
            columns={tableColumns}
            rows={filteredEquipments}
            scrollY={tableBodyHeight}
            renderCell={(field, equipment) => (
              <EquipmentTableCell
                field={field}
                equipment={equipment}
                onAction={handleAction}
              />
            )}
            sortBy={sortField}
            sortDir={sortDir}
            onSort={handleSort}
          />
          {CwFPagination(
            totalEquipments,
            equipmentPageNumber,
            handlePageChange
          )}
        </Paper>
      ) : (
        <LandingList.LandingEmpty
          listType="Equipments"
          isSearch={isSearch}
          routePath={isSearch ? paths.equipment : `${paths.equipment}/item`}
        />
      )}
    </div>
  );
};

EquipmentList.propTypes = {
  equipments: PropTypes.arrayOf(PropTypes.object),
  isSearch: PropTypes.bool,
  totalEquipments: PropTypes.number.isRequired,
  equipmentPageNumber: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired,
  setItems: PropTypes.func.isRequired
};

export default EquipmentList;
